import axios from "axios";
import { app } from "../../api";

const apiUrl = app;

//================================================ container ======================================================
export function loadAcademic(pageLimit, page, search, order) {
  return axios.get(
    `${apiUrl}/acdemic/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}
export function loadAcademicYear(name) {
  return axios.get(
    `${apiUrl}/acdemic/list?name=${name}`
  );
}

export function loadActiveAcademic() {
  return axios.get(`${apiUrl}/acdemic/list?is_active=true`);
}

export function addAcademic(data) {
  return axios.post(`${apiUrl}/acdemic`, data);
}

//================================================ container ======================================================
export function loadAlmanac(pageLimit, page, search, order) {
  return axios.get(
    `${apiUrl}/almanac/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function addAlmanac(data) {
  return axios.post(`${apiUrl}/almanac`, data);
}

export function loadActiveAlmanac() {
  return axios.get(`${apiUrl}/almanac/active`);
}

//================================================ container ======================================================
export function loadSchool(code) {
  return axios.get(`${apiUrl}/school/list?code=${code}`);
}

export function addSchool(data) {
  return axios.post(`${apiUrl}/school`, data);
}

//================================================ container ======================================================
export function loadDepartment(code) {
  return axios.get(`${apiUrl}/department/list?code=${code}`);
}

export function addDepartment(data) {
  return axios.post(`${apiUrl}/department`, data);
}

//================================================ container ======================================================
export function loadProgramme(code) {
  return axios.get(`${apiUrl}/programme/list?code=${code}`);
}

export function loadProgrammeList(pageLimit, page, search, order) {
  return axios.get(
    `${apiUrl}/programme/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function addProgramme(data) {
  return axios.post(`${apiUrl}/programme`, data);
}

//================================================ container ======================================================
export function loadStudent(pageLimit, page, search, order) {
  return axios.get(
    `${apiUrl}/student/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadStudentReg(registration_number) {
  return axios.get(
    `${apiUrl}/student/list?registration_number=${registration_number}`
  );
}

export function loadStudentData(id) {
  return axios.get(
    `${apiUrl}/student/data/${id}`
  );
}

export function loadActiveStudent(pageLimit, page, search, order) {
  return axios.get(
    `${apiUrl}/student/list?limit=${pageLimit}&offset=${page}&is_active=${'true'}&search=${search}&ordering=${order}`
  );
}

export function loadActiveStudentByFilter(
  pageLimit,
  page,
  name,
  registration,
  programme,
  level,
  study,
  verified,
  order
) {
  const params = new URLSearchParams({
    limit: pageLimit,
    offset: page,
    full_name__icontains: name,
    registration_number__icontains: registration,
    programme__id: programme,
    qualification_level__icontains: level,
    study__study_year: study,
    is_verified: verified,
    ordering: order,
  });

  return axios.get(`${apiUrl}/student/list?${params.toString()}`);
}

export function loadActiveStudentByStudent(pageLimit, page, reg, order) {
  return axios.get(
    `${apiUrl}/student/list?limit=${pageLimit}&offset=${page}&is_active=${"true"}&registration_number=${reg}&ordering=${order}`
  );
}

export function requestStudent(data) {
  return axios.post(`${apiUrl}/amis/student`, data);
}

export function addStudent(data) {
  return axios.post(`${apiUrl}/student`, data);
}

export function patchStudentData(id, data) {
  return axios.patch(`${apiUrl}/student/update/${id}`, data);
}

//================================================ container ======================================================
export function loadStudy(pageLimit, page, search, order) {
  return axios.get(
    `${apiUrl}/study/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadStudentStudy(pageLimit, page, student, search, order) {
  return axios.get(
    `${apiUrl}/study/list?limit=${pageLimit}&offset=${page}&student__id=${student}&search=${search}&ordering=${order}`
  );
}

export function loadStudentStudyActive(student, order) {
  return axios.get(
    `${apiUrl}/study/list?student__id=${student}&is_active=true&ordering=${order}`
  );
}

export function addStudy(data) {
  return axios.post(`${apiUrl}/study`, data);
}

//================================================ container ======================================================
export function loadCard(pageLimit, page, search, order) {
  return axios.get(
    `${apiUrl}/card/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadStudentCard(pageLimit, page, student, search, order) {
  return axios.get(
    `${apiUrl}/card/list?limit=${pageLimit}&offset=${page}&student__id__in=${student}&search=${search}&ordering=${order}`
  );
}

export function addCard(data) {
  return axios.post(`${apiUrl}/card`, data);
}








//============================================= dashboard =========================================================
export function loadDashboardTotal() {
  return axios.get(`${apiUrl}/data/total`);
}
export function loadDashboardDataDays() {
  return axios.get(`${apiUrl}/data/day`);
}

export function loadDashboardDataType() {
  return axios.get(`${apiUrl}/data/type`);
}
